export enum RatingAccountType {
    None = 0,
    Vendor = 1,
    Developer = 2,
    Fleet = 3,
    CallCenter = 4
}